<template>
  <div class="wrapper">
      <img src="../../assets/zanwu.png" alt="">
      <div>暂 无 数 据 ...</div>
  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){},
  mounted(){}
}
</script>
<style lang="less" scoped>
.wrapper{
  img{
    margin-bottom: 20px;
  }
  margin: 100px auto;
  color:#8a8a8a;
  text-align: center;
}
</style> 